<template>
    <div class="page-wrapper">
        <div class="bg" :class="{'bg--visible': slidedata.type === 'intro'}" />
        <div>
            <div class="topbar">
                <div>
                    <a href="#" class="prev-step" @click.prevent="prevStep" v-if="slidedata.type !== 'intro'">
                        <span>
                            <i class="icon-arrow-left"/>
                        </span>
                        {{ $appdata.previousStep }}
                    </a>
                </div>
                <a href="/"><img class="logo" :src="$appdata.logoUrl" :width="$appdata.logoSize" /></a>
            </div>

            <div class="loader" :class="{'loader--progress-is-visible': loading}">
                <div class="loader__el"></div>
            </div>

            <form class="main slides" @submit.prevent novalidate>
                <transition name="page" mode="out-in" @leave="scrollTo">
                    <component
                        :is="slideComponent"
                        @nextStep="nextStep"
                        @finalStep="finalStep"
                        @restart="restart"
                        :slidedata="slidedata"
                        :datamodel="datamodel"
                        :key="slidedata.step"
                    />
                </transition>
            </form>
        </div>

        <div class="contact-bar contact-bar--show">
            <div class="contact-bar__address">
                <strong>{{ $appdata.footer.company }} </strong> {{ $appdata.footer.address }}
            </div>
            <div class="contact-bar__contact-details">
                {{ $appdata.footer.tel }} <a :href="$appdata.footer.webPath" target="_blank">{{ $appdata.footer.web }}</a>
            </div>
        </div>

        <div class="progress" :class="{'progress--show': (slidedata.step && slidedata.step < slidedata.stepOf)}">
            <div class="progress__bar">
                <div class="progress__status" :style="{width: `${(slidedata.step / slidedata.stepOf) * 100}%`}"></div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api';

export default {
    data() {
        return {
            slidedata: {
                type: null,
            },
            componentLoading: true,
            slideComponent: null,
            datamodel: {},
            history: [{
                dataset: {
                    type: 'intro',
                },
                datamodel: {},
            }],
            loading: false,
        };
    },
    methods: {
        restart() {
            this.history = [{
                dataset: {
                    type: 'intro',
                },
                datamodel: {},
            }];

            this.loadStepData();
        },
        finalStep(dataset) {
            const historyItem = {
                datamodel: {},
                dataset,
            };

            this.history.unshift(historyItem);

            this.loadStepData(historyItem);
        },
        nextStep(data, processForm = false, overwriteHistory = false) {
            const historyItem = {
                datamodel: { ...this.datamodel, ...data },
                dataset: {},
            };

            if (overwriteHistory) {
                this.history.shift();
            }

            this.history.unshift(historyItem);

            this.loading = true;

            if (processForm === false) {
                api.post('/process', historyItem.datamodel).then((response) => {
                    historyItem.dataset = response.data;
                    this.loadStepData(historyItem);
                    this.loading = false;
                }).catch(() => {
                    alert('Er is een fout opgetreden!');
                    this.loading = false;
                });
            } else {
                api.post('/process-form', historyItem.datamodel).then((response) => {
                    historyItem.dataset = response.data;
                    this.loadStepData(historyItem);
                    this.loading = false;
                }).catch(() => {
                    alert('Er is een fout opgetreden!');
                    this.loading = false;
                });
            }
        },
        scrollTo() {
            window.scrollTo(0, 0);
        },
        async loadStepData() {
            const item = this.history[0];

            this.slideComponent = await this.loadComponent(item.dataset.type);

            this.slidedata = item.dataset;
            this.datamodel = item.datamodel;

            if (this.slidedata.entity_id) {
                this.datamodel.entity_id = this.slidedata.entity_id;
            }
        },
        prevStep() {
            this.history.shift();
            this.loadStepData();
        },
        async loadComponent(name) {
            const component = await import(`@/components/slides/${name}.vue`);
            return component.default;
        },
    },
    created() {
        this.slidedata.type = 'intro';
        this.loadStepData();
    },
};
</script>
